export default __webpack_public_path__ + "static/media/096.dc556711.jpg";